import styled from 'styled-components';
import { Card } from '@ovotech/element-v5';
import { breakpoints } from '@/src/utils/mediaQuery';

export const RewardsCard = styled(Card)`
  padding: 35px 40px;
  border-radius: 4px;

  @media ${breakpoints.smallDown} {
    padding: 32px 24px;
  }
`;

export const RewardsCardContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media ${breakpoints.smallDown} {
    flex-direction: column-reverse;
    align-items: flex-start;
  }
`;

export const RewardsCardTextContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media ${breakpoints.smallDown} {
    width: 100%;
  }
`;

export const RewardsCardActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
  margin-top: 24px;

  @media ${breakpoints.smallDown} {
    flex-direction: column;
    align-items: center;
    width: 100%;

    & > button,
    & > a {
      width: 100%;
    }
  }
`;

export const RewardsCardImageContainer = styled.div`
  flex-shrink: 0;

  @media ${breakpoints.smallDown} {
    margin-bottom: 16px;
  }
`;
